import * as actions from './actions'

const defaultSectionFormState = {
  isSubmitting: false,
  submitError: '',
  newSectionId: '',
  submitWasSuccessful: false,
  isAutoGenerating: true,
  passwords: {}
}

const sectionFormReducer = (state = defaultSectionFormState, action) => {
  switch(action.type) {
    case actions.BEGIN_SECTION_CREATE:
      return Object.assign({}, state, { isSubmitting: true, submitError: '', newSectionId: '', submitWasSuccessful: false })
    case actions.CLEAR_PASSWORDS:
      return Object.assign({}, state, { passwords: {} })
    case actions.SECTION_CREATE_SUCCESS:
      return Object.assign({}, state, { isSubmitting: false, newSectionId: action.newSectionId, submitWasSuccessful: true })
    case actions.SECTION_CREATE_FAILURE:
      return Object.assign({}, state, { isSubmitting: false, submitError: action.errorMessage })
    case actions.BEGIN_SECTION_UPDATE:
      return Object.assign({}, state, { isSubmitting: true, submitError: '', newSectionId: '', submitWasSuccessful: false })
    case actions.SECTION_UPDATE_SUCCESS:
      return Object.assign({}, state, { isSubmitting: false, submitWasSuccessful: true, passwords: action.passwords })
    case actions.SECTION_UPDATE_FAILURE:
      return Object.assign({}, state, { isSubmitting: false, submitError: action.errorMessage })
    case actions.SECTION_SUBMIT_SUCCESS_HANDLED:
      return Object.assign({}, state, { submitWasSuccessful: false })
    case actions.SET_FIELD_AUTO_GENERATION:
      return Object.assign({}, state, { isAutoGenerating: action.isAutoGenerating })
    case actions.RESET_SECTION_FORM:
      const { passwords, ...rest } = defaultSectionFormState
      return Object.assign({}, state, rest)
    default:
      return state
  }
}

export default sectionFormReducer;
